'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface StageItem {
  number: string
  title: string
  description: string
}

const WorkStages: React.FC = () => {
  const stages: StageItem[] = [
    {
      number: '01',
      title: 'Аналитика',
      description: 'Анализируем текущие ИТ-процессы и задачи бизнеса. Составляем стратегию с учётом бюджета, сложности продукта и масштабирования на будущее. Готовим персональное решение, полностью адаптированное под задачи бизнеса.'
    },
    {
      number: '02',
      title: 'Проектирование и ТЗ',
      description: 'Разрабатываем архитектуру взаимодействия систем (API) и пишем техническое задание. Мы заранее продумываем логику обмена данными и правила обработки ошибок, чтобы будущая интеграция была стабильной и безопасной.'
    },
    {
      number: '03',
      title: 'Разработка и тестирование',
      description: 'Создаём программные шлюзы для передачи информации и настраиваем фильтры данных. Проводим серию тестов на разных сценариях, чтобы убедиться: синхронизация работает безупречно, а информация передаётся без искажений.'
    },
    {
      number: '04',
      title: 'Запуск и сопровождение',
      description: 'Переносим решение в рабочую среду и обучаем вашу команду работе в обновлённой системе. После запуска мы остаёмся рядом: следим за стабильностью обмена данными и помогаем адаптировать интеграции под новые задачи бизнеса.'
    }
  ]

  return (
    <section className={styles.workStages}>
      <div className={styles.container}>
        <div className={styles.content}>
          <AnimatedSection animation="slideUp">
            <div className={styles.subtitle}>Этапы работы</div>
            <h2 
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: '<span>От аналитики до сопровождения</span> продукта после запуска' }}
            />
          </AnimatedSection>
          
          <div className={styles.items}>
            {stages.map((item, index) => (
              <AnimatedSection key={index} animation="slideUp">
                <div className={styles.item}>
                  <div className={styles.itemHeader}>
                    <div className={styles.itemNumber}>{item.number}</div>
                    <h3 className={styles.itemTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.itemDescription}>{item.description}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

WorkStages.displayName = 'WorkStages'

export default WorkStages